import { RootState } from 'redux/rootReducer';
import isEqual from 'lodash/isEqual';
import { createSelectorCreator, defaultMemoize } from 'reselect';
const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const getActiveReasons = createDeepEqualSelector(
  (state: RootState) => state.reasons.reasons,
  (reasons) => reasons.filter((reason) => reason.active)
);
